import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import TextToImage from './components/TextToImage';
import UserProfile from './components/UserProfile';
import UserCenter from './components/UserCenter';
import Login from './components/Login';
import Register from './components/Register';
import ProtectedRoute from './components/ProtectedRoute';
import AdminApp from './components/AdminApp';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={
              <ProtectedRoute>
                <TextToImage />
              </ProtectedRoute>
            } />
            <Route path="/my" element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            } />
            <Route path="/user-center/:userId" element={
              <ProtectedRoute>
                <UserCenter />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={<AdminApp />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;